import type { ReactNode } from "react";
import {
  findRidePageBackgroundStyle,
  findRideStyles,
} from "../styles/findRide.styles";

type FindRidePageShellProps = {
  children: ReactNode;
};

/**
 * Presentational page chrome: full-bleed cover background + readable overlay.
 * Keeps layout/background out of the page ViewModel and form components.
 */
export function FindRidePageShell({ children }: FindRidePageShellProps) {
  return (
    <div className={findRideStyles.pageShell} style={findRidePageBackgroundStyle}>
      <div className={findRideStyles.pageOverlay} aria-hidden />
      <div className={findRideStyles.content}>{children}</div>
    </div>
  );
}
